import React from "react";
import { createPortal } from "react-dom";

const Modal = ({ children, onClose, maxWidth = "max-w-2xl", heightClass = "h-[90vh] max-h-[90vh]", noPadding = false }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div
        className={`bg-theme-main rounded-lg w-full ${maxWidth} ${heightClass} flex flex-col overflow-hidden ${noPadding ? "p-0" : "p-6"}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
